<template>
  <div class="expected-Delivery-date_approve">
    <CustomerScheduleChangeFilling
      ref="customerScheduleChangeFilling"
      v-loading="isLoading"
      is-detail
      :application-id="applicationId"
      :change-type="changeType"
      :status="approveStatus"
    />
    <BasicInformation ref="basicInformation" v-loading="isLoading" :tatol-cny="tatolCny" />
    <DetailedInformation
      ref="detailedInformation"
      v-loading="isLoading"
      :change-type="changeType"
      :approve-status="approveStatus"
      @totalCny="totalCny"
    />
    <OperationRecordHistory :application-id="applicationId" />
    <BottomButtonGroup @cancel="handleCancel" />
  </div>
</template>

<script>
import CustomerScheduleChangeFilling from '../components/CustomerScheduleChangeFilling/index.vue';
import { mapState } from 'vuex';
import BasicInformation from '../components/BasicInformation.vue';
import DetailedInformation from './components/DetailedInformation.vue';
import OperationRecordHistory from '@/views/ExpectedDeliveryDate/components/OperationRecordHistory.vue';
import { getCeddChangeDetail } from '@/API/international';
import BottomButtonGroup from '@/views/ExpectedDeliveryDate/components/BottomButtonGroup.vue';

export default {
  name: 'Approve',
  components: { BottomButtonGroup, OperationRecordHistory, DetailedInformation, BasicInformation, CustomerScheduleChangeFilling },
  data () {
    return {
      applicationId: '',
      isDelay: false,
      changeType: '',
      approveStatus: '',
      isAdvance: false,
      isLoading: false,
      tatolCny: 0

    };
  },
  computed: {
    ...mapState(['isCollapse'])
  },
  methods: {
    totalCny (val) {
      this.tatolCny = val;
    },
    getDetailData () {
      this.isLoading = true;
      // 获取数据
      getCeddChangeDetail(this.applicationId).then((res) => {
        let json = res.data;
        if (json.status === '200') {
          this.changeType = json.data.form.type;
          this.$refs.customerScheduleChangeFilling.setDefaultFormData(json.data);
          this.$refs.basicInformation.setDefaultFormData(json.data);
          this.$refs.detailedInformation.setDefaultFormData(json.data);
          this.approveStatus = json.data.base.status || '';
        }
      }).catch((e) => {
        console.log(e);
      }).finally(() => {
        this.isLoading = false;
      });
    },
    // 获取下拉
    getSelectList () {
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', { dictType: 'CEDD_CHANGE_TYPE', type: 'changeType' });
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', { dictType: 'CEDD_CHANGE_ADVANCE', type: 'changeAdvance' });
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', { dictType: 'CEDD_CHANGE_DELAY', type: 'changeDelay' });
      this.$store.dispatch('enumeration/GET_CODE_CHANGE', { dictType: 'CEDD_CHANGE_STATUS', type: 'changeStatus' });
    },
    handleCancel () {
      this.$router.replace({
        path: '/expectedDeliveryDateApplyList'
      });
    }
  },
  mounted () {
    this.applicationId = this.$route.query.applicationId;
    this.getSelectList();
    this.getDetailData();
  }
};
</script>

<style scoped lang="scss">
.expected-Delivery-date_approve {
  margin-bottom: 60px;
  :deep(.rj-page-card) {
    min-width: 860px;
  }
}
</style>
